<template lang="pug">
.d-flex.flex-wrap.align-center.gap-2.my-4
  .d-flex.flex-wrap.align-center.gap-2.flex-grow-1
    filter-name(ref="nameFilter" :filter.sync="nameFilter" :check-initial-value="true")

    yz-filter-menu(label="Created date" :is-active="dateFilter.active" :display-value="dateFilter.value" @clear="clearDateFilter" @apply="applyDateFilter")
      .pa-4
        yz-date-picker(v-model="dateFilter.tempValue" range)

  yz-btn(label="Reset filters" text underline @click="onResetFilters" :disabled="!hasActiveFilters")
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'

export default {
  components: {
    FilterName
  },
  props: {
    filters: { type: Array, default: () => [] }
  },
  data: () => ({
    isInitializing: false,
    nameFilter: {},
    dateFilter: {
      active: false,
      value: '',
      tempValue: null
    }
  }),
  computed: {
    allFilters() {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.dateFilter.active && this.dateFilter.tempValue) {
        filters.push({
          key: 'date',
          value: this.dateFilter.tempValue,
          active: this.dateFilter.active
        })
      }
      return filters
    },
    hasActiveFilters() {
      return this.nameFilter.key || this.dateFilter.active
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler(newFilters) {
        this.initializeFromFilters(newFilters)
      }
    },
    allFilters(newValue) {
      if (!this.isInitializing) {
        this.$emit('update:filters', newValue)
      }
    }
  },
  methods: {
    async initializeFromFilters(filters) {
      if (!filters || filters.length === 0) return

      // Skip if already initializing or if filters match current state
      if (this.isInitializing) return
      if (JSON.stringify(filters) === JSON.stringify(this.allFilters)) return

      this.isInitializing = true

      try {
        // Find name filter from the filters array
        const nameKeys = ['name', 'name__ne', 'name__contains', 'name__exclude', 'name__startswith', 'name__endswidth']
        const nameFilterData = filters.find(f => nameKeys.includes(f.key))

        if (nameFilterData) {
          // Only update if different from current state
          if (this.nameFilter.key !== nameFilterData.key || this.nameFilter.value !== nameFilterData.value) {
            this.nameFilter = { ...nameFilterData }

            // Wait for refs to be available and restore UI state
            await this.$nextTick()

            if (this.$refs.nameFilter) {
              this.$refs.nameFilter.option = nameFilterData.key
              this.$refs.nameFilter.value = nameFilterData.value
              this.$refs.nameFilter.selectedOption = nameFilterData.key
              this.$refs.nameFilter.selectedValue = nameFilterData.value
            }
          }
        }

        // Restore date filter
        const dateFilter = filters.find(f => f.key === 'date')
        if (dateFilter) {
          this.dateFilter = {
            active: true,
            value: Array.isArray(dateFilter.value) ? dateFilter.value.join(' - ') : dateFilter.value,
            tempValue: dateFilter.value
          }
        }
      } finally {
        this.isInitializing = false
      }
    },
    applyDateFilter() {
      if (this.dateFilter.tempValue) {
        this.dateFilter.active = true
        if (Array.isArray(this.dateFilter.tempValue)) {
          this.dateFilter.value = this.dateFilter.tempValue.join(' - ')
        } else {
          this.dateFilter.value = this.dateFilter.tempValue
        }
      }
    },
    clearDateFilter() {
      this.dateFilter = { active: false, value: '', tempValue: null }
    },
    resetFilters() {
      this.nameFilter = {}
      this.dateFilter = { active: false, value: '', tempValue: null }

      // Reset child filter via ref
      if (this.$refs.nameFilter) {
        this.$refs.nameFilter.clearData()
      }
    },
    onResetFilters() {
      this.resetFilters()
      this.$emit('reset')
    }
  }
}
</script>
